import { createFileRoute } from '@tanstack/react-router'
import MarketingPage from '@/pages/dashboard/marketing-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/',
)({
  component: function MarketingRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingPage />
      </RequireModule>
    )
  },
})
